module.exports = "<div class=\"lp_view_avatar avatar doubleBorder sizeMedium\"><div class=\"avatar_online_presence\"></div></div>";